import { IPermissionsContext } from "../../ipermissions-context/ipermissions-context.interface";
import { IPermissions } from "../../ipermissions/ipermissions.interface";
import { hasUserGroup } from "../../ipermissions-context/ipermissions-context.functions";
import { UserGroup } from "../../../../../constants/types";
import { enablePermissions } from "../../ipermissions/ipermissions.functions";
import { IPermissionPolicyEvaluator } from "../../ipermissions/ipermission-policy.type";

export const generalUserGroupPolicy = (next?: IPermissionPolicyEvaluator) => (
  context: IPermissionsContext,
  permissions: IPermissions
) => {
  // console.log("checkGeneralUserPolicy -->");
  if (hasUserGroup(context, UserGroup.GENERAL_USERS)) {
    // console.log("checkGeneralUserPolicy --> TRUE");

    enablePermissions(permissions, "manageCampBriefs");
    enablePermissions(permissions, "manageExecBriefs");
    enablePermissions(permissions, "manageWorkOrders");

    return;
  }

  if (next) {
    return next(context, permissions);
  }
};
